var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_2220_1620)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7855 9.00007C14.4305 9.00007 14.1426 9.28789 14.1426 9.64293V16.0714C14.1426 16.4264 13.8548 16.7143 13.4998 16.7143H1.92855C1.5735 16.7143 1.28568 16.4264 1.28568 16.0714V3.21443C1.28568 2.85939 1.5735 2.57157 1.92855 2.57157H9.64273C9.99778 2.57157 10.2856 2.28376 10.2856 1.92871C10.2856 1.57366 9.99778 1.28589 9.64273 1.28589H1.92855C0.863439 1.28589 0 2.14933 0 3.21443V16.0714C0 17.1365 0.863439 17.9999 1.92855 17.9999H13.4998C14.5649 17.9999 15.4284 17.1365 15.4284 16.0714V9.6429C15.4284 9.28789 15.1406 9.00007 14.7855 9.00007Z",
    fill: "#04BA96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.2794 0.721124C17.0509 0.492546 16.7795 0.311233 16.4809 0.187544C16.1823 0.0638554 15.8622 0.00021361 15.539 0.000254461C15.2156 -0.00068546 14.8953 0.0625876 14.5965 0.186404C14.2978 0.31022 14.0267 0.492115 13.7988 0.721538L5.33115 9.18846C5.26091 9.25924 5.2079 9.34525 5.17623 9.43981L3.89054 13.2969C3.77834 13.6338 3.96045 13.9978 4.29731 14.1099C4.36266 14.1317 4.4311 14.1428 4.49996 14.1429C4.56898 14.1428 4.63754 14.1317 4.7031 14.1101L8.56019 12.8244C8.65492 12.7928 8.74099 12.7395 8.81154 12.6689L17.2791 4.20128C18.2402 3.24032 18.2403 1.68219 17.2794 0.721124Z",
    fill: "#04BA96"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2220_1620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.1a3fe1255f94a9dd6b43745ecec67fa3.svg";
export { ForwardRef as ReactComponent };